var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289 275.5L309 246.5L270.5 262Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 246.5L247 245L270.5 262Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 335.5L308.5 312L289 275.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 276L334.5 253.5L309 246.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 275.5L338 276L309 246.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.5 253.5L308 197.5L309 246.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 246.5L308 197.5L247 245Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 300L289 275.5L270.5 262Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 275.5L308.5 312L338 276Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 245L235.5 283.5L270.5 262Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5 283.5L240.5 300L270.5 262Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5 305L344 296.5L338 276Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 276L382.5 261L334.5 253.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.5 253.5L312 190L308 197.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 200L227 227L247 245Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 200L247 245L308 197.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 245L214 271.5L235.5 283.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5 312L337.5 305L338 276Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5 283.5L238 301.5L240.5 300Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 300L292 335.5L289 275.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 308L238 301.5L235.5 283.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5 150.5L246 200L308 197.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.5 231.5L214 271.5L247 245Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 333L292 335.5L240.5 300Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5 312L340.5 323.5L337.5 305Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.5 183L212.5 231.5L227 227Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 227L212.5 231.5L247 245Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 335.5L340.5 323.5L308.5 312Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5 305L340.5 323.5L344 296.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 271.5L222 308L235.5 283.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 301.5L247 333L240.5 300Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5 150.5L237.5 183L246 200Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 200L237.5 183L227 227Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 308L247 333L238 301.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 296.5L382.5 261L338 276Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.5 253.5L402.5 228.5L312 190Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 310.5L382.5 261L344 296.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 190L258.5 150.5L308 197.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5 261L402.5 228.5L334.5 253.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 190L282.5 136L258.5 150.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 308L208.5 338L247 333Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5 388L325.5 373.5L292 335.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 319L208.5 338L222 308Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 319L222 308L214 271.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5 125.5L282.5 136L312 190Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.5 136L267.5 137.5L258.5 150.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5 150.5L231 150L237.5 183Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.5 183L195 158L212.5 231.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5 137.5L231 150L258.5 150.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 364.5L292 335.5L247 333Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 335.5L325.5 373.5L340.5 323.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 323.5L402.5 310.5L344 296.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.5 261L451 271.5L402.5 228.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 346L402.5 310.5L340.5 323.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5 338L224 364.5L247 333Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 129L292.5 125.5L312 190Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.5 136L271 118.5L267.5 137.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5 137.5L271 118.5L231 150Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 319L214 271.5L139 298Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5 314L173.5 319L139 298Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5 338L186 350L224 364.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 364.5L311.5 388L292 335.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 346L438 308L402.5 310.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5 109L195 158L231 150Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 150L195 158L237.5 183Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 319L177 333L208.5 338Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 319L174.5 329.5L177 333Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5 125.5L271 118.5L282.5 136Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 180L414.5 189L467 204.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 228.5L414.5 189L312 190Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 333L186 350L208.5 338Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 343.5L186 350L177 333Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5 137L355 129L312 190Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5 125.5L293 110.5L271 118.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5 329.5L178 343.5L177 333Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 129L293 110.5L292.5 125.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 164L375.5 137L312 190Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5 189L408 164L312 190Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 319L152.5 314L174.5 329.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5 329.5L138.5 356.5L178 343.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 298L214 271.5L212.5 231.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5 189L412 165.5L408 164Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 164L402 150L375.5 137Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5 189L423 180L412 165.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 239L414.5 189L402.5 228.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5 159.5L402 150L412 165.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 165.5L402 150L408 164Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5 111L292 98.5L293 110.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 110.5L292 98.5L271 118.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 118.5L200.5 109L231 150Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5 111L293 110.5L355 129Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 271.5L139 298L212.5 231.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 346L340.5 323.5L407 392.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 310.5L451 271.5L382.5 261Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5 106.5L362.5 111L406 105.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5 137L362.5 111L355 129Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 308L451 271.5L402.5 310.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 364.5L289 417L311.5 388Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 392.5L340.5 323.5L325.5 373.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 417L289 417L224 364.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 392.5L325.5 373.5L379.5 420.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 308L465.5 281L451 271.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 105.5L362.5 111L375.5 137Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5 111L363.5 106.5L292 98.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 271.5L458 239L402.5 228.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 399L224 364.5L186 350Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 399L240.5 417L224 364.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 399L186 350L138.5 356.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 68.5L200.5 109L218.5 57.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 243.5L111.5 271.5L212.5 231.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 356.5L174.5 329.5L152.5 314Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 356.5L186 350L178 343.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 346L455.5 313.5L438 308Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 271.5L466.5 277.5L458 239Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 180L439.5 159.5L412 165.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 150L406 105.5L375.5 137Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 160.5L439.5 159.5L423 180Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.5 313.5L465.5 281L438 308Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.5 281L466.5 277.5L451 271.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 243.5L212.5 231.5L91 230.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5 335L138.5 356.5L152.5 314Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 420.5L325.5 373.5L365.5 432.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 383L509.5 341L455.5 313.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5 335L152.5 314L113.5 324.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.5 195L467 204.5L525 224Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 239L467 204.5L414.5 189Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5 108L148 135L195 158Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 417.5L187.5 410.5L192 399Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 399L211 440L240.5 417Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 392.5L426 383L425 346Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5 324.5L152.5 314L139 298Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5 432.5L311.5 388L289 417Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5 432.5L325.5 373.5L311.5 388Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 392.5L451 409.5L426 383Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5 117.5L406 105.5L402 150Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5 106.5L297.5 18L292 98.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 271.5L113.5 324.5L139 298Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 230.5L212.5 231.5L195 158Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 271.5L80.5 283L113.5 324.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 73.5L164.5 108L200.5 109Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5 109L164.5 108L195 158Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5 488.5L365.5 432.5L307.5 500.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 420.5L402.5 433L407 392.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 468.5L289 417L240.5 417Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 204.5L461 160.5L423 180Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5 117.5L411 96.5L406 105.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 410L178 417.5L192 399Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 440L216 441.5L240.5 417Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 410L192 399L138.5 356.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 123.5L125.5 144.5L148 135Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 135L125.5 144.5L195 158Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5 117.5L402 150L439.5 159.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 105.5L411 96.5L363.5 106.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5 108L140 123.5L148 135Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 144.5L91 230.5L195 158Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 243.5L80.5 283L111.5 271.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 440L192 399L187.5 410.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 417.5L211 440L187.5 410.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 454.5L225 446.5L227 482.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 441.5L225 446.5L240.5 417Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.5 195L477 165.5L467 204.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 204.5L477 165.5L461 160.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 160.5L446.5 117.5L439.5 159.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 482.5L225 446.5L216 441.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 446.5L231.5 454.5L240.5 417Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 482.5L216 441.5L211 440Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 57.5L200.5 109L271 118.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5 108L137 109L140 123.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 57.5L271 118.5L292 98.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.5 106.5L446.5 117.5L461 160.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 123.5L121 131L125.5 144.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 144.5L83.5 194.5L91 230.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 109L121 131L140 123.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5 18L218.5 57.5L292 98.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 71L187.5 71.5L197 68.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 68.5L187.5 71.5L200.5 109Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 431L402.5 433L411.5 450.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5 432.5L402.5 433L379.5 420.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 83.5L137 109L164.5 108Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 230.5L80.5 283L97.5 243.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 406.5L138.5 356.5L58.5 376.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 406.5L143.5 410L138.5 356.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 65.5L185 71L197 68.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5 71.5L173.5 73.5L200.5 109Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 433L410 431L407 392.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 319L503.5 294L455.5 313.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 356.5L120.5 335L58.5 376.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 505L227 482.5L166 506Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5 136.5L83.5 194.5L125.5 144.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 242L28 335.5L80.5 283Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 454.5L266 468.5L240.5 417Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 65.5L173.5 73.5L185 71Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 71L173.5 73.5L187.5 71.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.5 313.5L503.5 294L465.5 281Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.5 281L503.5 294L466.5 277.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.5 277.5L525 224L458 239Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.5 313.5L425 346L495 383Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5 117.5L437 91L411 96.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5 0L297.5 18L361.5 0Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.5 106.5L437 91L446.5 117.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 224L467 204.5L458 239Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5 119.5L466.5 106.5L461 160.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 25.5L174 65.5L197 68.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 73.5L144.5 83L164.5 108Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 419.5L451 409.5L407 392.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 376.5L120.5 335L113.5 324.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 410L126.5 431.5L178 417.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 120.5L98.5 136.5L121 131Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 131L98.5 136.5L125.5 144.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 120.5L121 131L120 96Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 65.5L144.5 83L173.5 73.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 65L143.5 83.5L144.5 83Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5 83L143.5 83.5L164.5 108Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 431L449 419.5L407 392.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 341L510 319L455.5 313.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 346L426 383L495 383Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.5 294L525 224L466.5 277.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5 450.5L421 443.5L410 431Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 431L421 443.5L449 419.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5 450.5L402.5 433L384.5 466Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 426L124 414.5L125.5 406.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 406.5L124 414.5L143.5 410Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 454.5L227 482.5L266 468.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.5 466L402.5 433L365.5 432.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5 119.5L461 160.5L477 165.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 96L121 131L137 109Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 239.5L12 242L0 236Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5 488.5L384.5 466L365.5 432.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 65L120 96L143.5 83.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 83.5L120 96L137 109Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 383L426 383L451 409.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 506L211 440L178 417.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5 500.5L365.5 432.5L289 417Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 39.5L363.5 106.5L411 96.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 57.5L225 25.5L197 68.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 290.5L503.5 294L510 319Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 290.5L525 224L503.5 294Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.5 195L498.5 119.5L477 165.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5 18L225 25.5L218.5 57.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 65.5L134.5 65L144.5 83Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 426L126.5 431.5L124 414.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 414.5L126.5 431.5L143.5 410Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.5 401.5L451 409.5L476 428.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.5 401.5L495 383L451 409.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.5 455.5L449 419.5L421 443.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5 489.5L436.5 455.5L411.5 450.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5 500.5L289 417L266 468.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 13.5L134.5 65L174 65.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 96L97.5 98L102 120.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 541L307.5 500.5L266 468.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.5 31L410 39.5L437 91Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 91L410 39.5L411 96.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 65L97.5 98L120 96Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 120.5L34.5 80L98.5 136.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 428.5L451 409.5L449 419.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 319.5L510 319L509.5 341Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.5 455.5L421 443.5L411.5 450.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5 489.5L411.5 450.5L384.5 466Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 177L498.5 119.5L503.5 195Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.5 87L423.5 31L437 91Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 463.5L476 428.5L449 419.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5 0L308 0L297.5 18Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5 18L241 0L225 25.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5 0L297.5 18L363.5 106.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 513.5L383.5 493L362.5 488.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5 488.5L383.5 493L384.5 466Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.5 455.5L453 463.5L449 419.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.5 493L395.5 489.5L384.5 466Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 0L241 0L297.5 18Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 25.5L171.5 0L174 65.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 506L227 482.5L211 440Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 482.5L221 505L266 468.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 0L240 0L225 25.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 335.5L42.5 335.5L80.5 283Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 283L42.5 335.5L113.5 324.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 283L91 230.5L12 242Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.5 87L437 91L466.5 106.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 39.5L361.5 0L363.5 106.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5 119.5L489.5 87L466.5 106.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 335.5L58.5 376.5L113.5 324.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5 0L361.5 0L410 39.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5 489.5L453 463.5L436.5 455.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 319.5L558.5 290.5L510 319Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 224L560 177L503.5 195Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5 119.5L534 105.5L489.5 87Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 319.5L509.5 341L564.5 364Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 341L495 383L564.5 364Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 -31.5L389.5 0L463.5 -24.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.5 31L389.5 0L410 39.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.5 452L490.5 401.5L476 428.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.5 364L495 383L560 393.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.5 493L380 513.5L395.5 489.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.5 478L475.5 469L465 491Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5 500.5L367.5 517.5L362.5 488.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5 544.5L367.5 517.5L307.5 500.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5 517.5L380 513.5L362.5 488.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 242L91 230.5L83.5 194.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 335.5L24 373.5L58.5 376.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.5 469L483.5 452L453 463.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 463.5L483.5 452L476 428.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 474L117 470.5L126.5 431.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 431.5L166 506L178 417.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 426L125.5 406.5L58.5 376.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 242L0 203L0 236Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 319.5L566.5 292L558.5 290.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 290.5L600 248L525 224Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 470.5L166 506L126.5 431.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 505L262 541L266 468.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 373.5L68 426L58.5 376.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5 0L358.5 -17.5L361.5 0Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5 0L358.5 -17.5L313.5 0Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5 0L358.5 -17.5L308 0Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 0L222 -39.5L241 0Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 0L222 -39.5L240 0Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 0L171.5 0L225 25.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 65L89.5 25.5L97.5 98Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 -39.5L171.5 0L240 0Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 214L560 177L525 224Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5 0L145.5 13.5L174 65.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 242L83.5 194.5L0 203Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.5 469L453 463.5L465 491Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 393.5L495 383L490.5 401.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 445.5L107.5 474L126.5 431.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 470.5L152 517L166 506Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 177L534 105.5L498.5 119.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.5 87L461.5 0L423.5 31Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5 577L262 541L221 505Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5 194.5L0 146.5L0 203Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 242L0 336.5L28 335.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5 194.5L98.5 136.5L0 146.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 335.5L24 373.5L42.5 335.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 426L63.5 445.5L126.5 431.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 362L24 373.5L28 335.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 491L453 463.5L395.5 489.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.5 469L478.5 478L483.5 452Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 541L337.5 544.5L307.5 500.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5 517.5L403 529L380 513.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 529L465 491L395.5 489.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 529L395.5 489.5L380 513.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 146.5L98.5 136.5L0 131Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 319.5L600 316.5L566.5 292Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 393.5L490.5 401.5L532 465Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 395.5L63.5 445.5L68 426Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5 474L152 517L117 470.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 506L196.5 577L221 505Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 514L152 517L107.5 474Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 571L403 529L367.5 517.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5 0L377 -31.5L358.5 -17.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.5 -17.5L222 -39.5L308 0Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.5 0L389.5 0L423.5 31Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 91.5L533.5 78L534 105.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 105.5L533.5 78L489.5 87Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 413L574.5 353L564.5 364Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.5 364L574.5 353L556 319.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 156L576.5 139.5L560 177Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 239.5L0 336.5L12 242Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 373.5L0 395.5L68 426Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 -31.5L222 -39.5L358.5 -17.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 8.5L134.5 65L145.5 13.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 541L337 553.5L337.5 544.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5 544.5L379.5 571L367.5 517.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.5 404.5L560 393.5L532 465Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 8.5L145.5 13.5L100 0Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 8.5L89.5 25.5L134.5 65Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 413L582 348L574.5 353Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.5 353L582 348L556 319.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 0L461.5 0L489.5 87Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 25.5L49.5 63L97.5 98Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0L145.5 13.5L171.5 0Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 25.5L47 0L49.5 63Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 259.5L558.5 290.5L566.5 292Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 177L576.5 139.5L534 105.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 336.5L0 362L28 335.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 80L102 120.5L97.5 98Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 63L34.5 80L97.5 98Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 239.5L-6.5 344L0 336.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 336.5L-6.5 344L0 362Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5 201L-6.5 344L0 239.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5 201L0 239.5L0 236Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5 201L0 236L0 203Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.5 277.5L600 259.5L566.5 292Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 259.5L600 248L558.5 290.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 316.5L601.5 277.5L566.5 292Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 259.5L601.5 277.5L600 248Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5 124L600 214L600 248Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 248L600 214L525 224Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.5 344L0 372.5L0 362Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 362L0 372.5L24 373.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 80L0 131L98.5 136.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 146.5L-34.5 201L0 203Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 413L600 316.5L582 348Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 348L600 316.5L556 319.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 -39.5L100 0L171.5 0Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 8.5L100 0L89.5 25.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.5 0L0 109L34.5 80Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 465L490.5 401.5L483.5 452Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 393.5L570.5 404.5L564.5 364Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 465L483.5 452L478.5 478Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 445.5L79 493.5L107.5 474Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 514L79 493.5L18 483Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.5 8L484 0L533.5 78Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.5 78L484 0L489.5 87Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.5 0L463.5 -24.5L389.5 0Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 515L478.5 478L465 491Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 515L532 465L478.5 478Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 514L143.5 541L152 517Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 517L196.5 577L166 506Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 600L379.5 571L337 553.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.5 445L0 395.5L-40.5 434Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 372.5L0 395.5L24 373.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L34.5 80L49.5 63Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 80L0 109L0 131Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 131L-34.5 201L0 146.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 214L600 156L560 177Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.5 139.5L588 91.5L534 105.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5 124L600 156L600 214Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5 124L600 155.5L600 156Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 156L600 155.5L576.5 139.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 553.5L379.5 571L337.5 544.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 529L495 515L465 491Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 587.5L337 553.5L262 541Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 0L463.5 -24.5L461.5 0Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 109L-34.5 201L0 131Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 395.5L0 372.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 600L495 515L403 529Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 600L310 587.5L262 541Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 493.5L77.5 514L107.5 474Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 483L79 493.5L63.5 445.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 564.5L196.5 577L143.5 541Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 541L196.5 577L152 517Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5 124L600 126.5L600 155.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 155.5L600 126.5L576.5 139.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 0L550.5 8L463.5 -24.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 126.5L588 91.5L576.5 139.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5 600L285 600L262 541Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 587.5L314 600L337 553.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5 600L268.5 600L262 541Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 600L314 600L310 587.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 452.5L595.5 418L570.5 404.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.5 404.5L600 413L564.5 364Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 416.5L595.5 418L600 452.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 514L131.5 564.5L143.5 541Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.5 577L239.5 600L262 541Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.5 277.5L612.5 124L600 248Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 126.5L600 93L588 91.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 497.5L612.5 124L601.5 277.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 497.5L601.5 277.5L600 316.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.5 418L600 413L570.5 404.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5 600L239.5 600L196.5 577Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 452.5L570.5 404.5L532 465Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.5 418L600 416.5L600 413Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 497.5L621.5 40.5L612.5 124Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5 124L600 93L600 126.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34.5L550.5 8L533.5 78Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -25.5L47 0L100 0Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0L47 0L89.5 25.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -25.5L44.5 0L47 0Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 0L44.5 0L49.5 63Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.5 445L18 483L63.5 445.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 600L127 594.5L131.5 564.5Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 600L374 600L337 553.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5 571L429.5 595.5L403 529Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5 600L198.5 600L196.5 577Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 0L550.5 8L585 11Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 569L543 515.5L495 515Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 515L543 515.5L532 465Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 600L412.5 600L379.5 571Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 480L600 452.5L532 465Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 497.5L600 316.5L600 413Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 564.5L162.5 600L196.5 577Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 594.5L162.5 600L131.5 564.5Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5 600L429.5 595.5L379.5 571Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 395.5L-25.5 445L63.5 445.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 372.5L-6.5 344Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 600L356 618.5L314 600Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 600L356 618.5L374 600Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 600L356 618.5L412.5 600Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 626.5L446 600L429.5 595.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5 600L356 618.5L285 600Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 631.5L356 618.5L268.5 600Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 631.5L268.5 600L239.5 600Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 631.5L239.5 600L198.5 600Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5 201L-40.5 434L-6.5 344Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.5 445L0 507L18 483Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 520.5L77.5 514L18 483Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 600L131.5 564.5L110.5 600Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 626.5L429.5 595.5L412.5 600Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5 595.5L446 600L403 529Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34.5L533.5 78L588 91.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.5 8L571 0L463.5 -24.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34.5L588 91.5L600 93Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.5 40.5L600 34.5L600 93Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34.5L585 11L550.5 8Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 511L600 480L543 515.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 515.5L600 480L532 465Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 497.5L600 413L600 416.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 507L-25.5 445Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 509.5L0 507Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 507L5.5 520.5L18 483Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 0L0 0L49.5 63Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 109L-28.5 0L-34.5 201Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -25.5L0 0L44.5 0Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 600L131.5 564.5L74.5 587Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 594.5L165 631.5L162.5 600Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5 600L165 631.5L198.5 600Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494 600L519 569L495 515Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 587L131.5 564.5L77.5 514Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 600L165 631.5L127 594.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 509.5L5.5 520.5L0 507Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 521.5L5.5 520.5L0 509.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 521.5L0 509.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 565.5L74.5 587L77.5 514Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5 124L621.5 40.5L600 93Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L591.5 0L585 11Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.5 497.5L600 416.5L600 452.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L585 11L600 34.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 11L591.5 0L571 0Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 0L591.5 0L463.5 -24.5Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 565.5L77.5 514L5.5 520.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 600L165 631.5L110.5 600Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 600L165 631.5L113 600Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.5 40.5L618.5 30.5L600 34.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 618.5L434.5 626.5L412.5 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 600L494 600L495 515Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 631.5L434.5 626.5L356 618.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 575L37.5 565.5L5.5 520.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 626.5L494 600L446 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 526.5L600 511L543 515.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.5 30.5L600 0L600 34.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.5 0L600 0L463.5 -24.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.5 556L543 515.5L519 569Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 480L628.5 497.5L600 452.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 -39.5L0 -25.5L100 0Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L-28.5 0L34.5 80Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 603.5L77 600L74.5 587Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 587L77 600L110.5 600Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.5 600L563.5 556L519 569Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -25.5L-28.5 0L0 0Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 626.5L508.5 600L494 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494 600L508.5 600L519 569Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.5 556L600 526.5L543 515.5Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 511L628.5 497.5L600 480Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 526.5L628.5 497.5L600 511Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 600L57.5 603.5L37.5 565.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 565.5L57.5 603.5L74.5 587Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 600L57.5 603.5L165 631.5Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 575L0 521.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 521.5L0 575L5.5 520.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 581L0 575Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 575L0 581L37.5 565.5Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5 434L0 600L0 581Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 581L0 600L37.5 565.5Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 603.5L0 600L165 631.5Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.5 556L622.5 581.5L600 526.5Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 526.5L622.5 581.5L628.5 497.5Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.5 600L600 600L563.5 556Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 626.5L600 600L508.5 600Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 600L622.5 581.5L563.5 556Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 626.5L611.5 600L600 600Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 600L611.5 600L622.5 581.5Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyBg2);
export default __webpack_public_path__ + "static/media/polyBG2.84f59cc04af7db3aa06fd37547a19d69.svg";
export { ForwardRef as ReactComponent };